export default __webpack_public_path__ + "static/media/photo--sm--51.c1cde51d.jpg";